import {Component, OnDestroy, OnInit} from '@angular/core';
import {SettingsService} from "../../core/settings/settings.service";
import {ThemesService} from "../../core/themes/themes.service";
import {TranslatorService} from "../../core/translator/translator.service";

declare var $: any;

@Component({
    selector: 'app-offsidebar',
    templateUrl: './offsidebar.component.html',
    styleUrls: ['./offsidebar.component.scss']
})
export class OffsidebarComponent implements OnInit, OnDestroy {

    currentTheme: any;
    selectedLanguage: string;
    clickEvent = 'click.offsidebar';
    $doc: any = null;

    constructor(public settings: SettingsService, public themes: ThemesService, public translator: TranslatorService) {
        this.currentTheme = themes.getDefaultTheme();
        this.selectedLanguage = this.getLangs()[0].code;
    }

    ngOnInit() {
        this.anyClickClose();
    }

    ngOnDestroy() {
        if (this.$doc) {
            this.$doc.off(this.clickEvent);
        }
    }

    setTheme() {
        this.themes.setTheme(this.currentTheme);
    }

    getLangs() {
        return this.translator.getAvailableLanguages();
    }

    setLang(value) {
        this.translator.useLanguage(value);
    }

    anyClickClose() {
        this.$doc = $(document).on(this.clickEvent, (e) => {
            if (!$(e.target).parents('.offsidebar').length) {
                this.settings.setLayoutSetting('offsidebarOpen', false);
            }
        });
    }
}
